// // import React, { useState, useEffect } from "react";
// // import { Grid, MenuItem, Select, TextField, Typography, InputLabel, FormControl } from "@mui/material";
// // import FormContainer from "../../../../components/Forms/FormContainer";
// // import { ExecuteApiToPost, ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
// // import { IPDCAttachFile1, IPDCFormattedJsonToDisplay } from "../../../../components/Controls";

// // const RegisterTerminationRequest = () => {
// //   const [agreements, setAgreements] = useState([]);
// //   const [selectedAgreement, setSelectedAgreement] = useState("");
// //   const [agreementDetails, setAgreementDetails] = useState(null);
// //   const [requestDate, setRequestDate] = useState("");
// //   const [reason, setReason] = useState("");
// //   const [description, setDescription] = useState("");
// //   const [file, setFile] = useState(null);
// //   const [loading, setLoading] = useState(false);

// //   useEffect(() => {
// //     // Fetch agreements from the API
// //     const fetchAgreements = async () => {
// //       try {
// //         const responseData = await GetDataFromApiWithParams("agreements/get-agreements-fortermination");
// //         setAgreements(responseData);
// //       } catch (error) {
// //         console.error("Error fetching agreements:", error);
// //       }
// //     };

// //     fetchAgreements();
// //   }, []);

// //   const handleAgreementChange = event => {
// //     const agreementId = event.target.value;
// //     setSelectedAgreement(agreementId);

// //     // Fetch details of the selected agreement
// //   //   const selected = agreements.find(agreement => agreement.id === agreementId);
// //   //   setAgreementDetails(selected);
// //   // };

// //   const selected = agreements.find(agreement => agreement.id === agreementId);
// //   // Create a copy without the linkage object (or with linkage converted to string)
// //   const safeAgreementDetails = {
// //     ...selected,
// //     linkage: selected?.linkage ? JSON.stringify(selected.linkage) : ''
// //   };
  
// //   setAgreementDetails(safeAgreementDetails);
// // };
// //   const handleSubmit = async event => {
// //     event.preventDefault();

// //     if (!selectedAgreement) return;
// //     // try {
// //     //   const formData = new FormData();
// //     //   formData.append("request_date", requestDate);
// //     //   formData.append("reason", reason);
// //     //   formData.append("description", description);
// //     //   if (file) formData.append("file", file);

// //     //   setLoading(true);
// //     //   const responseData = await ExecutePostWithParams(`agreements/${selectedAgreement}/terminationRequest`, formData,file);
// //     //****************************************** */
// //    try {
// //       const formData = new FormData();
// //       formData.append("request_date", requestDate);
// //       formData.append("reason", reason);
// //       formData.append("description", description);
// //       if (file) formData.append("file", file);

// //       setLoading(true);
// //       const responseData = await ExecutePostWithParams(`agreements/${selectedAgreement}/terminationRequest`, formData);
// //     //************************************************************* */
// //     console.log("Termination request submitted:", responseData);
// //       // Reset form after submission 
// //       setSelectedAgreement("");
// //       setAgreementDetails(null);
// //       setRequestDate("");
// //       setReason("");
// //       setDescription("");
// //       setFile(null);
// //       setLoading(false);
// //     } catch (error) {
// //       console.log(error);
// //     }
// //   };

// //   return (
// //     <FormContainer title="Register Termination Request" onSubmit={handleSubmit}>
// //       <Grid item xs={6}>
// //         <Grid container spacing={2}>
// //           <Grid item xs={12}>
// //             <FormControl fullWidth={true}>
// //               <InputLabel id="agreement-select-label">Select Agreement</InputLabel>
// //               <Select
// //                 labelId="agreement-select-label"
// //                 value={selectedAgreement}
// //                 onChange={handleAgreementChange}
// //                 label="Select Agreement"
// //               >
// //                 {agreements && agreements?.length > 0 &&agreements.map((agreement, index) => (
// //                   <MenuItem key={index} value={agreement.id}>
// //                     {agreement.id} 
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Grid>
// //           <Grid item xs={12} sm={6}>
// //             <TextField
// //               fullWidth={true}
// //               label="Request Date"
// //               type="date"
// //               value={requestDate}
// //               onChange={e => setRequestDate(e.target.value)}
// //               InputLabelProps={{ shrink: true }}
// //             />
// //           </Grid>
// //           <Grid item xs={12} sm={6}>
// //             <TextField fullWidth={true} label="Reason" value={reason} onChange={e => setReason(e.target.value)} />
// //           </Grid>
// //           <Grid item xs={12}>
// //             <TextField
// //               fullWidth={true}
// //               label="Description"
// //               multiline
// //               rows={4}
// //               value={description}
// //               onChange={e => setDescription(e.target.value)}
// //             />
// //           </Grid>
// //         </Grid>
// //       </Grid>
// //       <Grid item xs={6}>
// //         <Grid container>
// //           {agreementDetails && (
// //             <Grid item xs={12}>
// //               <Typography variant="subtitle1">Agreement Details:</Typography>
// //               <IPDCFormattedJsonToDisplay data={agreementDetails} />
// //             </Grid>
// //           )}
// //         </Grid>
// //       </Grid>
// //       <Grid item xs={6}>
// //         <IPDCAttachFile1 onChange={files => setFile(files[0])} isMultiple={true} />
// //       </Grid>
// //     </FormContainer>
// //   );
// // };

// // export default RegisterTerminationRequest;

// import React, { useState, useEffect } from "react";
// import { Grid, MenuItem, Select, TextField, Typography, InputLabel, FormControl } from "@mui/material";
// import FormContainer from "../../../../components/Forms/FormContainer";
// import { ExecuteApiToPost, ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
// import { IPDCAttachFile1, IPDCFormattedJsonToDisplay } from "../../../../components/Controls";
// import { toast } from 'react-toastify'; // Add this import

// const RegisterTerminationRequest = () => {
//   const [agreements, setAgreements] = useState([]);
//   const [selectedAgreement, setSelectedAgreement] = useState("");
//   const [agreementDetails, setAgreementDetails] = useState(null);
//   const [requestDate, setRequestDate] = useState("");
//   const [reason, setReason] = useState("");
//   const [description, setDescription] = useState("");
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     // Fetch agreements from the API
//     const fetchAgreements = async () => {
//       try {
//         const responseData = await GetDataFromApiWithParams("agreements/get-agreements-fortermination");
//         setAgreements(responseData);
//       } catch (error) {
//         console.error("Error fetching agreements:", error);
//         toast.error("Error fetching agreements"); // Add error toast
//       }
//     };

//     fetchAgreements();
//   }, []);

//   const handleAgreementChange = event => {
//     const agreementId = event.target.value;
//     setSelectedAgreement(agreementId);

//     // Fetch details of the selected agreement
//   //   const selected = agreements.find(agreement => agreement.id === agreementId);
//   //   setAgreementDetails(selected);
//   // };

//   const selected = agreements.find(agreement => agreement.id === agreementId);
//   // Create a copy without the linkage object (or with linkage converted to string)
//   const safeAgreementDetails = {
//     ...selected,
//     linkage: selected?.linkage ? JSON.stringify(selected.linkage) : ''
//   };
  
//   setAgreementDetails(safeAgreementDetails);
// };
//   const handleSubmit = async event => {
//     event.preventDefault();

//     if (!selectedAgreement) {
//       toast.warning("Please select an agreement"); // Add validation toast
//       return;
//     }
    
//     try {
//       const formData = new FormData();
//       formData.append("request_date", requestDate);
//       formData.append("reason", reason);
//       formData.append("description", description);
//       if (file) formData.append("file", file);

//       setLoading(true);
//       const responseData = await ExecutePostWithParams(`agreements/${selectedAgreement}/terminationRequest`, formData);
      
//       console.log("Termination request submitted:", responseData);
      
//       // Add success toast message
//       toast.success("Contract Termination requested successfully");
      
//       // Reset form after submission 
//       setSelectedAgreement("");
//       setAgreementDetails(null);
//       setRequestDate("");
//       setReason("");
//       setDescription("");
//       setFile(null);
//       setLoading(false);
//     } catch (error) {
//       console.log(error);
//       // Add error toast message
//       toast.error(error.response?.data?.message || "System error occurred, Please try again!");
//       setLoading(false);
//     }
//   };

//   return (
//     <FormContainer title="Register Termination Request" onSubmit={handleSubmit}>
//       <Grid item xs={6}>
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <FormControl fullWidth={true}>
//               <InputLabel id="agreement-select-label">Select Agreement</InputLabel>
//               <Select
//                 labelId="agreement-select-label"
//                 value={selectedAgreement}
//                 onChange={handleAgreementChange}
//                 label="Select Agreement"
//               >
//                 {agreements && agreements?.length > 0 &&agreements.map((agreement, index) => (
//                   <MenuItem key={index} value={agreement.id}>
//                     {agreement.id} 
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               fullWidth={true}
//               label="Request Date"
//               type="date"
//               value={requestDate}
//               onChange={e => setRequestDate(e.target.value)}
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField fullWidth={true} label="Reason" value={reason} onChange={e => setReason(e.target.value)} />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField
//               fullWidth={true}
//               label="Description"
//               multiline
//               rows={4}
//               value={description}
//               onChange={e => setDescription(e.target.value)}
//             />
//           </Grid>
//         </Grid>
//       </Grid>
//       <Grid item xs={6}>
//         <Grid container>
//           {agreementDetails && (
//             <Grid item xs={12}>
//               <Typography variant="subtitle1">Agreement Details:</Typography>
//               <IPDCFormattedJsonToDisplay data={agreementDetails} />
//             </Grid>
//           )}
//         </Grid>
//       </Grid>
//       <Grid item xs={6}>
//         <IPDCAttachFile1 onChange={files => setFile(files[0])} isMultiple={true} />
//       </Grid>
//     </FormContainer>
//   );
// };

// export default RegisterTerminationRequest;

//********************************************************************************************/
import React, { useState, useEffect } from "react";
import { Grid, MenuItem, Select, TextField, Typography, InputLabel, FormControl } from "@mui/material";
import FormContainer from "../../../../components/Forms/FormContainer";
import { ExecuteApiToPost, ExecutePostWithParams, GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";
import { IPDCAttachFile1, IPDCFormattedJsonToDisplay } from "../../../../components/Controls";
import { toast } from 'react-toastify';

const RegisterTerminationRequest = () => {
  const [agreements, setAgreements] = useState([]);
  const [selectedAgreement, setSelectedAgreement] = useState("");
  const [agreementDetails, setAgreementDetails] = useState(null);
  const [requestDate, setRequestDate] = useState("");
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch agreements from the API
    const fetchAgreements = async () => {
      try {
        const responseData = await GetDataFromApiWithParams("agreements/get-agreements-fortermination");
        setAgreements(responseData);
      } catch (error) {
        console.error("Error fetching agreements:", error);
        toast.error("Error fetching agreements");
      }
    };

    fetchAgreements();
  }, []);

  const handleAgreementChange = event => {
    const agreementId = event.target.value;
    setSelectedAgreement(agreementId);

    const selected = agreements.find(agreement => agreement.id === agreementId);
    
    // Recursively convert all nested objects to strings to avoid React rendering errors
    const safeAgreementDetails = {};
    if (selected) {
      Object.keys(selected).forEach(key => {
        const value = selected[key];
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          // Convert nested objects to JSON string
          safeAgreementDetails[key] = JSON.stringify(value);
        } else if (Array.isArray(value)) {
          // Handle arrays - stringify if they contain objects
          safeAgreementDetails[key] = value.map(item => 
            item && typeof item === 'object' ? JSON.stringify(item) : item
          );
        } else {
          safeAgreementDetails[key] = value;
        }
      });
    }
    
    setAgreementDetails(safeAgreementDetails);
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!selectedAgreement) {
      toast.warning("Please select an agreement");
      return;
    }
    
    try {
      const formData = new FormData();
      formData.append("request_date", requestDate);
      formData.append("reason", reason);
      formData.append("description", description);
      if (file) formData.append("file", file);

      setLoading(true);
      const responseData = await ExecutePostWithParams(`agreements/${selectedAgreement}/terminationRequest`, formData);
      
      console.log("Termination request submitted:", responseData);
      
      toast.success("Contract Termination requested successfully");
      
      // Reset form after submission 
      setSelectedAgreement("");
      setAgreementDetails(null);
      setRequestDate("");
      setReason("");
      setDescription("");
      setFile(null);
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "System error occurred, Please try again!");
      setLoading(false);
    }
  };

  return (
    <FormContainer title="Register Termination Request" onSubmit={handleSubmit}>
      <Grid item xs={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth={true}>
              <InputLabel id="agreement-select-label">Select Agreement</InputLabel>
              <Select
                labelId="agreement-select-label"
                value={selectedAgreement}
                onChange={handleAgreementChange}
                label="Select Agreement"
              >
                {agreements && agreements?.length > 0 && agreements.map((agreement, index) => (
                  <MenuItem key={index} value={agreement.id}>
                    {agreement.id} 
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth={true}
              label="Request Date"
              type="date"
              value={requestDate}
              onChange={e => setRequestDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth={true} label="Reason" value={reason} onChange={e => setReason(e.target.value)} />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth={true}
              label="Description"
              multiline
              rows={4}
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container>
          {agreementDetails && (
            <Grid item xs={12}>
              <Typography variant="subtitle1">Agreement Details:</Typography>
              <IPDCFormattedJsonToDisplay data={agreementDetails} />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <IPDCAttachFile1 onChange={files => setFile(files[0])} isMultiple={true} />
      </Grid>
    </FormContainer>
  );
};

export default RegisterTerminationRequest;